import config from '../../config';
import { authHeader } from '../_helpers';
import { applyCompanyPermissionsToUser } from '../utils/companyPermissionFlags';

export const userService = {
    login,
    logout,
    getAll,
    hasPermission
};

async function login(username, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
    };

    return fetch(`${config.apiUrl}/users/authenticate`, requestOptions)
        .then(handleResponse)
        .then(user => {
            if (user) {
                user.authdata = window.btoa(username + ':' + password);
                return hasPermission(user.accountId)
                    .then((result) => {
                        if (!user.username) {
                            return {};
                        }
                        const enriched = applyCompanyPermissionsToUser(user, result || []);
                        return fetch(
                            `${config.apiUrl}/getAccountTarget?account_id=${enriched.accountId}`,
                            { method: 'GET', headers: { 'Content-Type': 'application/json' } }
                        )
                            .then((res) => (res.ok ? res.json() : null))
                            .then((account) => {
                                if (account && account.companyName) {
                                    enriched.companyName = account.companyName;
                                }
                                localStorage.setItem('user', JSON.stringify(enriched));
                                return enriched;
                            })
                            .catch(() => {
                                localStorage.setItem('user', JSON.stringify(enriched));
                                return enriched;
                            });
                    });
            }

            return user;
        })
        .catch(
            error => window.alert(error)
        )
}

function hasPermission(account_id) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
    };
    return fetch(`${config.apiUrl}/checkPermission?account_id=${account_id}`, requestOptions)
        .then((response) => {
            return response.text().then(text => {
                const data = text && JSON.parse(text);
                return data;
            });
        })
        .then(result => result)
        .catch(
            error => console.error(error.message)
        )
}

function logout() {
    localStorage.removeItem('user');
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${config.apiUrl}/users`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                logout();
                location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}
